import React from 'react';
import { Button, ButtonProps } from '@chakra-ui/react';
import { useResponsive } from '../utils';

type QuizBtnProps = ButtonProps & {
  children: React.ReactNode;
  onClick: () => void;
};

export const QuizBtn: React.FC<QuizBtnProps> = ({
  children,
  onClick,
  ...rest
}: QuizBtnProps) => {
  const isMobileScreen = useResponsive();

  return (
    <Button
      type="submit"
      bgColor="black"
      color="white"
      w={isMobileScreen ? '100%' : 'fit-content'}
      mt={10}
      mb={5}
      p={6}
      onClick={onClick}
      {...rest}
    >
      {children}
    </Button>
  );
};
